import React from "react";
import { Link } from "react-router-dom";

/**
 * PEPTIGENIE wordmark — bold geometric sans, wide letter-spacing, navy with a
 * blue highlight on the second "E", and a short rule centred beneath.
 */
const LETTERS = ["P", "E", "P", "T", "I", "G", "E", "N", "I", "E"];

export const Logo = ({ className = "", dark = false, size = "text-[22px] sm:text-[26px]", tagline = true, taglineClassName = "" }) => {
  const navy = dark ? "#FFFFFF" : "#0B2E6E";
  const blue = dark ? "#7CC4FF" : "#1F5FDB";
  const colorFor = (i) => (i === 6 ? blue : navy);

  return (
    <Link to="/" className={`inline-flex flex-col items-center leading-none ${className}`} data-testid="brand-logo" aria-label="PEPTIGENIE home">
      <span
        className={`font-heading font-semibold uppercase ${size}`}
        style={{ letterSpacing: "0.55em", marginRight: "-0.55em", lineHeight: 1 }}
      >
        {LETTERS.map((ch, i) => (
          <span key={i} style={{ color: colorFor(i) }}>
            {ch}
          </span>
        ))}
      </span>
      <span
        aria-hidden="true"
        className="mt-2 block h-[3px] w-[16%]"
        style={{ backgroundColor: dark ? "#BFE9FF" : "#0B2E6E", marginRight: "-0.55em" }}
      />
      {tagline && (
        <span
          data-testid="brand-tagline"
          className={`mt-1.5 block whitespace-nowrap font-sans text-[7.5px] font-medium uppercase sm:text-[9px] ${taglineClassName}`}
          style={{ letterSpacing: "0.22em", marginRight: "-0.22em", color: dark ? "#BFD4EE" : "#4B5B73" }}
        >
          Research <span aria-hidden="true" className="mx-0.5">&bull;</span> Innovation <span aria-hidden="true" className="mx-0.5">&bull;</span> Wellness Science
        </span>
      )}
    </Link>
  );
};
